import { render } from "./LoyaltyPeriodTable.vue?vue&type=template&id=26525af6"
import script from "./LoyaltyPeriodTable.vue?vue&type=script&lang=js"
export * from "./LoyaltyPeriodTable.vue?vue&type=script&lang=js"

import "./LoyaltyPeriodTable.vue?vue&type=style&index=0&id=26525af6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__